import { Id } from "./id";

type ConfigurationProfile = {
  name: string;
  roles: Id[];
  columns: { key: string }[];
};

type ProjectElementDetailsConfiguration = ConfigurationProfile[];

const projectElementDetailsConfiguration: ProjectElementDetailsConfiguration =
  [];

export type { ProjectElementDetailsConfiguration };

export { projectElementDetailsConfiguration };
